import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Link } from 'react-router-dom';

export const Section = styled.section`
  padding: ${({ theme }) => theme.space['3xl']} ${({ theme }) => theme.space.xl};
  background-color: ${({ theme }) => theme.colors.background.primary};
`;

export const Container = styled.div`
  max-width: 1150px;
  margin: 0 auto;
`;

export const SectionTitle = styled.h2`
  font-size: ${({ theme }) => theme.typography.variants.heading2.fontSize}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  text-align: center;
  margin: 0 0 ${({ theme }) => theme.space.xl};
`;

export const ContentRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 30px;

  @media (max-width: 630px) {
    flex-direction: column;
    gap: 40px;
  }
`;

export const MainColumn = styled.div`
  flex: 0 0 50%;
  max-width: 50%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.md};

  @media (max-width: 992px) {
    flex: 0 0 45%;
    max-width: 45%;
  }

  @media (max-width: 630px) {
    flex: 1;
    max-width: 100%;
  }
`;

export const MainImageLink = styled(Link)`
  display: block;
  text-decoration: none;
  border-radius: ${({ theme }) => theme.radius.regular};
  overflow: hidden;
`;

export const MainImage = styled.img`
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  display: block;
`;

export const DescriptionBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.sm};
  padding: 0 ${({ theme }) => theme.space.sm};
`;

export const MainTitle = styled.h3`
  font-size: ${({ theme }) => theme.typography.variants.heading3.fontSize}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`;

export const MainDescription = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
`;

export const CTAWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.xs};
`;

export const GridColumn = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.space.lg};

  @media (max-width: 630px) {
    width: 100%;
    justify-items: center;
  }
`;

/* Skeleton styles */

const shimmer = keyframes`
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
`;

export const SkeletonBlock = styled.div<{ $width?: string; $height?: string; $aspectRatio?: string }>`
  width: ${({ $width }) => $width ?? '100%'};
  height: ${({ $height }) => $height ?? 'auto'};
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio ?? 'unset'};
  border-radius: ${({ theme }) => theme.radius.regular};
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.background.secondary} 0%,
    ${({ theme }) => theme.colors.background.primary} 50%,
    ${({ theme }) => theme.colors.background.secondary} 100%
  );
  background-size: 200% 100%;
  animation: ${shimmer} 1.5s infinite;
`;

export const SkeletonText = styled(SkeletonBlock)`
  height: 14px;
  border-radius: 4px;
  margin-top: ${({ theme }) => theme.space.sm};
`;
